export const getChipByBetValue = (chips, value) => chips.reduce((acc, chip) => (chip.value <= value ? chip : acc));
